
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Dette er brakt av
                    <a href="${0}">Folksonomy Engine prosjektet</a>. Ikke
                    nøl med å delta eller gi tilbakemelding`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Dette verktøyet lar deg korrigere ingredienslisten. Du kan legge til, fjerne eller redigere
                ingredienslisten.
                <br>
                – dette karakteret <span class="highlight">have</span> representerer et område.
                <br>
                Dette tegnet <span class="highlight">:time-_curving_left:</span> representerer en linjeskift. `,
'hb28f1f2ec1744ee9': html`Disse egenskapene opprettes og legges inn av brukere for alle typer bruk. Føler deg at
                    kan legge til ditt eget. Egenskapene og verdiene du oppretter
                    <strong>må være faktiske</strong>. Du kan dykke inn i
                    <a href="${0}">listen over egenskaper som allerede er brukt av fellesskapet</a>
                    eller utforske
                    <a href="${1}">egenskapenes dokumentasjon og søkemotor</a>.`,
's000a5b76bd3a01c2': `Laster egenskaper...`,
's000d98595e959c1e': `Få den på Google Play`,
's013bdc8cf0d3583d': `Hjelp oss for ingredienser`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Validate crop`,
's03e9c8114521b998': `Jeg skal redigere ingrediensene`,
's05ec315d9308091a': `Strekkode hjørner ikon`,
's061eb5af92512c85': `Lagret! Kan du hjelpe med en annen?`,
's06847c221c4c0bc1': `Jeg vil lage en egenskap til [beskrive din brukstilfelle]...`,
's06f6c6f99db6b552': `Opprinnelig`,
's081e2ad82db71e1d': `Grupperte verdier`,
's09205907b5b56cda': `Nei`,
's0b4235aae602a950': `dedikert dokumentasjon`,
's0bb2d48532acc455': `Last ned CSV`,
's0d5b7fee0311db68': `Eiendom`,
's0fb218abc2e157ed': `Ugyldiggjør bilde`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Avbryt beskjæring`,
's11a18a69b30b65ed': `Hjelp oss å fikse feil i ingredienslisten`,
's1205d5f6fccf8e69': `Egenskap verdi`,
's15d64a0a6715285a': `Ny nøkkel`,
's166bd56d19670a72': `Forstørr`,
's19059bf0c4f7c162': `Velg område`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Hjelp oss å korrigere næringsinformasjonen`,
's1e00019dc454872d': `Angi et egenskapsnavn ved å bruke attributtet egenskapsnavn.`,
's1e49126af0935a5b': `Liste over produkter med denne egenskapen`,
's21e73088de6f26f3': `Last ned fra App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Avbryt`,
's2db7b654c0a9bde0': `Dokumentet til egenskapen`,
's300b3a6ee4e1252d': str`Dårlig samsvar ${0}%`,
's33f786bb6b4f0cf4': `Beskjær Resultat`,
's33f85f24c0f5f008': `Lagre`,
's34be4af4e8fec4ae': `Spør samfunnet først`,
's36d86adc823cbfa6': `Før du skaper ny eiendom, diskuter den med samfunnet:`,
's3781d25aa51a736c': `Folksonomy Engine Dokumentasjon`,
's383ae4449428b61e': `Reset crop`,
's39bcf88721a1e8ee': `Tilbakestill valgte`,
's39e14e14300694c7': `Dokumentasjon og retningslinjer`,
's3b430cfa5c1fe7f4': str`Dokumentasjon for ${0}`,
's3f4e4b52f230a892': `Bilde lerret`,
's417b90913e05bc17': `Forhåndsvisning`,
's41f7dca46d3f1b4a': `Verdi`,
's422bba9636ce2489': `Sentrer bilde`,
's42dd66b2441566fd': `Sentrer ikon`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Legg til et næringsstoff`,
's453ab0dbb9b5c777': `Endre størrelse høyre`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Laster...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Antall produkter`,
's4df2f533c0c1e7d0': `Bilde kontroller`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Flytt valgte`,
's4f751fb9b3ed766c': `Opprette en ny egenskap`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Skriv inn egenskapsnavn...`,
's55d7249883a98ca1': `om denne eiendommen på Open Food Facts wiki`,
's565867d84c04aea2': `Filtrer egenskaper...`,
's5666afe5cd0166de': `Rett opp feilene eller endre teksten før du bekrefter`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Laster produkter ...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Hjelp oss å korrigere næringsinformasjonen.`,
's5dd6f12783fca34f': `Rediger ingrediens-liste`,
's5e8250fb85d64c23': `Lukk`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `JEG STØTTER`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Rediger `,
's66413c24dcf680e2': `Hopp over`,
's67ae6594857a4d57': `Takk for bidraget ditt!`,
's6cee7cad81dfedd1': `Beskjært bilde`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android-APK`,
's718dea04853f80ae': str`Godt treff ${0}%`,
's71a5c9f4b68ef4d4': `Antall`,
's74cb3d66f6a668e1': `Dokumentasjon`,
's787dd11bed0dc88a': `Endre størrelse til venstre`,
's7ce4fd9430e80cea': `verdi`,
's801a05fa8e881f37': `Lær mer om oppretting og retningslinjer for egenskaper:`,
's8038273de2cf8b73': `Velg et område å beskjære.`,
's839cc2908a5387f2': `Filtrer strekkoder...`,
's86197dcf3e96af64': `Bla gjennom og søk etter eksisterende egenskaper`,
's8a63be30a129a59c': `Endre størrelse nede`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Endre størrelse øverst til høyre`,
's8db84aa4bc949af2': `Dokumentet til ny egenskap`,
's8f839a03997a16d7': `Vis produkt`,
's901ae1e236ac45d3': `Avbryt sletting`,
's907f7a97c6b29425': `Vær oppmerksom på at datamodellen kan endres. Bruk på egen risiko.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Ingredienser :`,
's9a7f60fce090ecaf': `Kan ikke laste egenskaper. Prøv igjen senere.`,
's9b87abd68fb9df45': `Ikke funnet? Opprett ny nøkkel {value}`,
's9c0f52425fd2f07e': `Kan ikke matche`,
's9fc41f789c63b40d': `Produkter`,
'sa1fa766e0d5634d7': `Ingen resultat tilgjengelig`,
'sa548778b24054030': `Utforsk alle bidratt egenskaper fra Folksonomy Engine prosjektet. Disse egenskapene gir ytterligere metadata og innsikt om produkter i Open Food Facts databasen.`,
'sa63907958bd0ec4b': `Endre størrelse øverst til venstre`,
'sa95b4224f685a36a': `Lukk modal`,
'sab56a1d439576fd6': `Forslag til ikon`,
'sac47ea2901d04c15': `Endre størrelse nederst til venstre`,
'sb125227d436c2925': `Søk etter konseptet ditt i den eksisterende egenskapsdatabasen:`,
'sb125568d43642e6f': `Svar på spørsmål om produktet.`,
'sb1c538e038f9b214': str`Veldig bra kamp ${0}%`,
'sb28639570ff3b852': `liste over alle egenskaper`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Når du har bekreftet at egenskapen din ikke finnes, og fellesskapet er nyttig, må du først dokumentere det på wikien.`,
'sb3d4f79d9d8b71e5': `Send inn`,
'sb560fa37a7bfb6c2': `Ingen produkter funnet for denne egenskapen.`,
'sb7f72e4c8a2d3357': `Filtrer verdier...`,
'sb8178320160f84ea': `Vis beskjæring`,
'sbad7d2734149470b': `Godkjenn`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `All innsikt har blitt besvart! Takk for din hjelp!`,
'sbd9a0b2293b3cd3c': `Porsjonstørrelse`,
'sbe472dc3c2685985': `Tilsvarende verdi`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Endre størrelse på toppen`,
'sc1c08d0cbcc3bd24': `Samsvarer ikke`,
'sc52696641af72b53': `Installer appen!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Foreslått fiks`,
'sc681b137e8f604f7': `Bekreft sletting`,
'sc6daf8a31883f8b9': `Flytt bilde`,
'sc895972c88d38ca5': `Egenskaper for Folksonomi`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Rader`,
'scb3b0671d7b7f640': `Ny verdi`,
'scb489a1a173ac3f0': `Ja`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Bli med Slack-diskusjon`,
'scdb6cad0b92721bf': `Ingen egenskaper funnet.`,
'scf23a05631f93732': `Bekreft sletting`,
'scfed2f270ef6a3aa': `Velg område`,
'sd1022bc1ef9204f7': `Zoombart bilde`,
'sd1077c055cf9ba6b': `Hjelp oss med å validere ingredienslisten til produktet.`,
'sd698d21ddecba56b': `Hei! Du kan hjelpe oss med å forbedre produktinformasjonen ved å svare på følgende deler:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Sjekk om en egenskap allerede finnes`,
'sdbf806fefc584115': `Du burde finne en`,
'sdc673e73b5c13aea': `Slett`,
'sdc792b75f1edcaba': `Hjelp oss å korrigere stavemåten av ingredienser.`,
'sdca5deead576ceee': `Endre størrelse nederst til høyre`,
'sdcc2555c5dde524f': `Er du sikker på at du vil slette dette elementet? Handlingen kan ikke angres.`,
'se206feec7ec57b28': `per 100 g`,
'se419a9ab36987490': `Invalidate`,
'se5127cf0f92e7e48': `Tips: du kan også finne`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Jeg vil foreslå en bedre avling`,
'seea3800e27baa686': `Individuelle produkter`,
'sefaba4adc4ec9219': `Egenskaper for Folksonomi`,
'seffa8ca49175b5f0': `Personlige egenskaper`,
'sf44a6b3b232c28ea': str`Erstatt gjeldende verdi av ${0}`,
'sf4cd86a2f5ef2588': `Produkt strekkode`,
'sf57a61152168cc81': `Hjelp oss å korrigere ingrediensgjenkjenning`,
'sf88b90b8ba23871c': `Ukjent treff`,
'sf9aee319a006c9b4': `Legg til`,
'sfacbbe968fa7d773': `Egenskapens navn:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Tilsvarende verdi`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  